(function () {
  'use strict';

  /* --------------------------------------------------------
     Cookie helpers
  -------------------------------------------------------- */
  function setCookie(name, value, maxAge) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function getCookie(name) {
    var re = new RegExp('(?:^|; )' + name + '=([^;]*)');
    var match = document.cookie.match(re);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function clearCookie(name) {
    document.cookie = name + '=; path=/; max-age=0; SameSite=Lax';
  }

  document.querySelectorAll('[id^="dd-nq-"]').forEach(function (root) {
    var state = {
      step: 0,
      answers: [],
      totalQuestions: 0,
      emailStep: 0,
      resultsStep: 0
    };

    var allSteps     = root.querySelectorAll('.dd-nq__step');
    var qSteps       = root.querySelectorAll('.dd-nq__step--question');
    var resultBlocks = root.querySelectorAll('.dd-nq__step--result');
    var retakeRow    = root.querySelector('.dd-nq__retake');

    state.totalQuestions = qSteps.length;
    state.emailStep      = state.totalQuestions + 1;
    state.resultsStep    = state.totalQuestions + 2;

    /* -------------------------------------------------- */
    /* Navigation                                          */
    /* -------------------------------------------------- */

    function goToStep(n) {
      allSteps.forEach(function (s) {
        s.classList.remove('is-active');
      });

      // Result blocks use inline display — don't try to activate via CSS class
      var target = root.querySelector(
        '.dd-nq__step:not(.dd-nq__step--result)[data-step="' + n + '"]'
      );
      if (!target) return;

      target.classList.add('is-active');
      state.step = n;
      scrollToQuiz();
    }

    function scrollToQuiz() {
      var top = root.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    /* -------------------------------------------------- */
    /* Option selection                                    */
    /* -------------------------------------------------- */

    function handleOptionSelect(btn) {
      var group = btn.closest('.dd-nq__options');
      if (!group) return;

      group.querySelectorAll('.dd-nq__option').forEach(function (o) {
        o.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');

      var qIndex = parseInt(group.dataset.question, 10);
      state.answers[qIndex] = parseInt(btn.dataset.answerIndex, 10);

      var stepEl = btn.closest('.dd-nq__step');
      if (stepEl) {
        var nextBtn = stepEl.querySelector('.js-nq-next');
        if (nextBtn) nextBtn.disabled = false;
      }
    }

    /* -------------------------------------------------- */
    /* Result matching                                     */
    /* -------------------------------------------------- */

    function parseTrigger(str) {
      if (!str) return [];
      return str.split(',').map(function (part) {
        var m = part.trim().match(/Q(\d+)_A(\d+)/i);
        return m ? { q: parseInt(m[1], 10), a: parseInt(m[2], 10) } : null;
      }).filter(Boolean);
    }

    function matchResult() {
      if (!resultBlocks.length) return null;
      var best = resultBlocks[0];
      var bestScore = -1;
      resultBlocks.forEach(function (el) {
        var conditions = parseTrigger(el.dataset.trigger);
        var score = conditions.filter(function (c) {
          return state.answers[c.q - 1] === c.a;
        }).length;
        if (score > bestScore) {
          bestScore = score;
          best = el;
        }
      });
      return best;
    }

    /* -------------------------------------------------- */
    /* Show results                                        */
    /* -------------------------------------------------- */

    function showResults() {
      if (!resultBlocks.length) return;

      allSteps.forEach(function (s) {
        s.classList.remove('is-active');
      });

      var matched = matchResult();
      if (matched) {
        matched.style.display = 'block';
        matched.classList.add('is-active');
      }

      if (retakeRow) retakeRow.style.display = 'flex';
      state.step = state.resultsStep;
      scrollToQuiz();
    }

    /* -------------------------------------------------- */
    /* Copy discount code                                  */
    /* -------------------------------------------------- */

    function copyCode(code, btn) {
      if (!navigator.clipboard) return;
      var prevHTML = btn.innerHTML;
      navigator.clipboard.writeText(code).then(function () {
        btn.innerHTML = '<span style="font-size:11px;font-weight:800;letter-spacing:.08em;">Copied!</span>';
        btn.setAttribute('aria-label', 'Copied!');
        setTimeout(function () {
          btn.innerHTML = prevHTML;
          btn.setAttribute('aria-label', 'Copy discount code');
        }, 2000);
      });
    }

    /* -------------------------------------------------- */
    /* Retake quiz                                         */
    /* -------------------------------------------------- */

    function retakeQuiz() {
      state.answers = [];
      state.step    = 0;

      resultBlocks.forEach(function (el) {
        el.style.display = 'none';
        el.classList.remove('is-active');
      });

      root.querySelectorAll('.dd-nq__option.is-selected').forEach(function (o) {
        o.classList.remove('is-selected');
      });

      root.querySelectorAll('.js-nq-next').forEach(function (btn) {
        btn.disabled = true;
      });

      if (retakeRow) retakeRow.style.display = 'none';

      goToStep(0);
    }

    /* -------------------------------------------------- */
    /* Restore from post-redirect cookie                  */
    /* -------------------------------------------------- */

    var savedAnswers = getCookie('dd_nq_answers');
    if (getCookie('dd_nq_show') === '1' && savedAnswers) {
      clearCookie('dd_nq_show');
      clearCookie('dd_nq_answers');
      state.answers = savedAnswers.split(',').map(function (n) { return parseInt(n, 10); });
      showResults();
    }

    /* -------------------------------------------------- */
    /* Event delegation                                    */
    /* -------------------------------------------------- */

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;

      if (btn.classList.contains('js-nq-start')) {
        goToStep(1);

      } else if (btn.classList.contains('js-nq-next')) {
        if (!btn.disabled) goToStep(state.step + 1);

      } else if (btn.classList.contains('js-nq-back')) {
        goToStep(state.step - 1);

      } else if (btn.classList.contains('dd-nq__option')) {
        handleOptionSelect(btn);

      } else if (btn.classList.contains('js-nq-retake')) {
        retakeQuiz();

      } else if (btn.classList.contains('js-nq-copy-code')) {
        var code = btn.dataset.code;
        if (code) copyCode(code, btn);

      }
    });

    root.addEventListener('submit', function (e) {
      if (!e.target.classList.contains('js-nq-email-form')) return;
      // Persist answers to cookies before Shopify's form redirect
      setCookie('dd_nq_answers', state.answers.join(','), 300);
      setCookie('dd_nq_show', '1', 300);
      // No preventDefault — let the native form submit to Shopify
    });

  });
})();